import { Union } from "./fable_modules/fable-library-js.4.28.0/Types.js";
import { string_type, union_type } from "./fable_modules/fable-library-js.4.28.0/Reflection.js";
import { t } from "./Lang.js";
import { Step_guests, Step_cards, Step_arrangements, Step_rules, Step_tables, Tab_guests, Step_rsvp, Tab_export, Tab_arrangements, Tab_rules, Tab_floorPlan, Tab_tables } from "./Shared/Tr.js";
import { tail, head, isEmpty, filter, singleton, ofArray } from "./fable_modules/fable-library-js.4.28.0/List.js";
import { map } from "./fable_modules/fable-library-js.4.28.0/Option.js";
import { split, substring } from "./fable_modules/fable-library-js.4.28.0/String.js";
import { tryFind } from "./fable_modules/fable-library-js.4.28.0/Array.js";

export class EventTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Guests", "Tables", "FloorPlan", "Rules", "Arrangements", "Export", "Sharing", "Rsvp"];
    }
}

export function EventTab_$reflection() {
    return union_type("Client.Router.EventTab", [], EventTab, () => [[], [], [], [], [], [], [], []]);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Login", "ForgotPassword", "ResetPassword", "Account", "Contact", "EventList", "EventDetail", "NotFound"];
    }
}

export function Page_$reflection() {
    return union_type("Client.Router.Page", [], Page, () => [[], [], [["token", string_type]], [], [], [], [["id", string_type], ["tab", EventTab_$reflection()]], []]);
}

export function EventTabModule_toUrlSegment(_arg) {
    switch (_arg.tag) {
        case 1:
            return "/tables";
        case 2:
            return "/floor-plan";
        case 3:
            return "/rules";
        case 4:
            return "/arrangements";
        case 5:
            return "/export";
        case 6:
            return "/sharing";
        case 7:
            return "/rsvp";
        default:
            return "";
    }
}

/**
 * Parses URL segment to EventTab. External input — catch-all required.
 */
export function EventTabModule_fromString(_arg) {
    switch (_arg) {
        case "guests":
            return new EventTab(0, []);
        case "tables":
            return new EventTab(1, []);
        case "floor-plan":
            return new EventTab(2, []);
        case "rules":
            return new EventTab(3, []);
        case "arrangements":
            return new EventTab(4, []);
        case "export":
            return new EventTab(5, []);
        case "sharing":
            return new EventTab(6, []);
        case "rsvp":
            return new EventTab(7, []);
        case "overview":
            return new EventTab(0, []);
        case "settings":
            return new EventTab(0, []);
        default:
            return new EventTab(0, []);
    }
}

export function EventTabModule_label(_arg) {
    switch (_arg.tag) {
        case 1:
            return t(Tab_tables);
        case 2:
            return t(Tab_floorPlan);
        case 3:
            return t(Tab_rules);
        case 4:
            return t(Tab_arrangements);
        case 5:
            return t(Tab_export);
        case 6:
            return "Sharing";
        case 7:
            return t(Step_rsvp);
        default:
            return t(Tab_guests);
    }
}

export const EventTabModule_all = ofArray([new EventTab(0, []), new EventTab(1, []), new EventTab(2, []), new EventTab(3, []), new EventTab(4, []), new EventTab(5, []), new EventTab(6, []), new EventTab(7, [])]);

export class WorkflowStep extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GuestsStep", "TablesStep", "RulesStep", "ArrangementsStep", "CardsStep", "RsvpStep"];
    }
}

export function WorkflowStep_$reflection() {
    return union_type("Client.Router.WorkflowStep", [], WorkflowStep, () => [[], [], [], [], [], []]);
}

export const WorkflowStepModule_all = ofArray([new WorkflowStep(0, []), new WorkflowStep(1, []), new WorkflowStep(2, []), new WorkflowStep(3, []), new WorkflowStep(4, []), new WorkflowStep(5, [])]);

export function WorkflowStepModule_stepNumber(_arg) {
    switch (_arg.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        default:
            return 1;
    }
}

export function WorkflowStepModule_label(_arg) {
    switch (_arg.tag) {
        case 1:
            return t(Step_tables);
        case 2:
            return t(Step_rules);
        case 3:
            return t(Step_arrangements);
        case 4:
            return t(Step_cards);
        case 5:
            return t(Step_rsvp);
        default:
            return t(Step_guests);
    }
}

export function WorkflowStepModule_icon(_arg) {
    switch (_arg.tag) {
        case 1:
            return "🪑";
        case 2:
            return "🌍";
        case 3:
            return "✨";
        case 4:
            return "";
        case 5:
            return "📩";
        default:
            return "📋";
    }
}

/**
 * The primary (default) tab for each step
 */
export function WorkflowStepModule_defaultTab(_arg) {
    switch (_arg.tag) {
        case 1:
            return new EventTab(1, []);
        case 2:
            return new EventTab(3, []);
        case 3:
            return new EventTab(4, []);
        case 4:
            return new EventTab(5, []);
        case 5:
            return new EventTab(7, []);
        default:
            return new EventTab(0, []);
    }
}

/**
 * All tabs belonging to a step (for sub-tab rendering)
 */
export function WorkflowStepModule_tabs(_arg) {
    switch (_arg.tag) {
        case 1:
            return ofArray([new EventTab(1, []), new EventTab(2, [])]);
        case 2:
            return singleton(new EventTab(3, []));
        case 3:
            return singleton(new EventTab(4, []));
        case 4:
            return ofArray([new EventTab(5, []), new EventTab(6, [])]);
        case 5:
            return singleton(new EventTab(7, []));
        default:
            return singleton(new EventTab(0, []));
    }
}

/**
 * Which step does a given tab belong to?
 */
export function WorkflowStepModule_fromTab(_arg) {
    switch (_arg.tag) {
        case 1:
            return new WorkflowStep(1, []);
        case 2:
            return new WorkflowStep(1, []);
        case 3:
            return new WorkflowStep(2, []);
        case 4:
            return new WorkflowStep(3, []);
        case 5:
            return new WorkflowStep(4, []);
        case 6:
            return new WorkflowStep(4, []);
        case 7:
            return new WorkflowStep(5, []);
        default:
            return new WorkflowStep(0, []);
    }
}

/**
 * Does this step have sub-tabs (more than one tab)?
 */
export function WorkflowStepModule_hasSubTabs(_arg) {
    switch (_arg.tag) {
        case 1:
            return true;
        case 2:
            return false;
        case 3:
            return false;
        case 4:
            return true;
        case 5:
            return false;
        default:
            return false;
    }
}

function extractQueryParam(segment, paramName) {
    const qIdx = segment.indexOf("?") | 0;
    if (qIdx < 0) {
        return undefined;
    }
    else {
        return map((p_1) => substring(p_1, paramName.length + 1), tryFind((p) => p.startsWith(`${paramName}=`), split(substring(segment, qIdx + 1), ["&"], undefined, 0)));
    }
}

export function parseHash(hash) {
    let qIdx;
    const trimmed = hash.startsWith("#/") ? substring(hash, 2) : (hash.startsWith("#") ? substring(hash, 1) : hash);
    const segments = filter((s) => (s !== ""), ofArray(split((qIdx = (trimmed.indexOf("?") | 0), (qIdx >= 0) ? substring(trimmed, 0, qIdx) : trimmed), ["/"], undefined, 0)));
    let matchResult, id, id_1, tab;
    if (!isEmpty(segments)) {
        switch (head(segments)) {
            case "login": {
                if (isEmpty(tail(segments))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "forgot-password": {
                if (isEmpty(tail(segments))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "account": {
                if (isEmpty(tail(segments))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "contact": {
                if (isEmpty(tail(segments))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "reset-password": {
                if (isEmpty(tail(segments))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "event": {
                if (!isEmpty(tail(segments))) {
                    if (!isEmpty(tail(tail(segments)))) {
                        if (isEmpty(tail(tail(tail(segments))))) {
                            matchResult = 7;
                            id_1 = head(tail(segments));
                            tab = head(tail(tail(segments)));
                        }
                        else {
                            matchResult = 8;
                        }
                    }
                    else {
                        matchResult = 6;
                        id = head(tail(segments));
                    }
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            default:
                matchResult = 8;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(5, []);
        case 1:
            return new Page(0, []);
        case 2:
            return new Page(1, []);
        case 3:
            return new Page(3, []);
        case 4:
            return new Page(4, []);
        case 5: {
            const matchValue = extractQueryParam(trimmed, "token");
            if (matchValue == null) {
                return new Page(7, []);
            }
            else {
                return new Page(2, [matchValue]);
            }
        }
        case 6:
            return new Page(6, [id, new EventTab(0, [])]);
        case 7:
            return new Page(6, [id_1, EventTabModule_fromString(tab)]);
        default:
            return new Page(7, []);
    }
}

export function toHash(page) {
    switch (page.tag) {
        case 1:
            return "#/forgot-password";
        case 2:
            return `#/reset-password?token=${page.fields[0]}`;
        case 3:
            return "#/account";
        case 4:
            return "#/contact";
        case 5:
            return "#/";
        case 6:
            return `#/event/${page.fields[0]}${EventTabModule_toUrlSegment(page.fields[1])}`;
        case 7:
            return "#/404";
        default:
            return "#/login";
    }
}

export function navigateTo(page) {
    const hash = toHash(page);
    window.location.hash = hash;
}

export function currentPage() {
    return parseHash(window.location.hash);
}

